import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import UpgradeModal from './UpgradeModal';
import '../pages/Pages.css';

const PLAN_ORDER = ['free', 'basic', 'team_s', 'team_m', 'enterprise'];

const PLAN_INFO: Record<string, { label: string; price: string }> = {
  free: { label: 'Free Trial', price: 'kostenlos' },
  basic: { label: 'Einzelcoach', price: '49 EUR/Monat' },
  team_s: { label: 'Professional S', price: '99 EUR/Monat' },
  team_m: { label: 'Professional M', price: '179 EUR/Monat' },
  enterprise: { label: 'Organisation', price: 'auf Anfrage' },
};

export function canAccessPlan(userPlan: string, requiredPlan: string): boolean {
  return PLAN_ORDER.indexOf(userPlan) >= PLAN_ORDER.indexOf(requiredPlan);
}

interface FeatureGateProps {
  requiredPlan: 'free' | 'basic' | 'team_s' | 'team_m' | 'enterprise';
  currentPlan: string;
  featureName: string;
  featureDescription?: string;
  children: React.ReactNode;
}

export default function FeatureGate({
  requiredPlan,
  currentPlan,
  featureName,
  featureDescription,
  children,
}: FeatureGateProps) {
  const [showUpgrade, setShowUpgrade] = useState(false);

  if (canAccessPlan(currentPlan, requiredPlan)) {
    return <>{children}</>;
  }

  const planInfo = PLAN_INFO[requiredPlan];

  return (
    <>
      <div className="feature-gate">
        <Lock size={32} style={{ color: 'var(--text-muted)', marginBottom: 12 }} />
        <h3 style={{ margin: '0 0 8px' }}>{featureName}</h3>
        {featureDescription && (
          <p className="text-muted" style={{ margin: '0 0 16px', fontSize: '0.9rem', maxWidth: 400, marginInline: 'auto' }}>
            {featureDescription}
          </p>
        )}
        <p className="text-muted text-sm" style={{ margin: '0 0 20px' }}>
          Verfügbar ab <strong>{planInfo.label}</strong> ({planInfo.price})
        </p>
        <button className="btn btn-primary" onClick={() => setShowUpgrade(true)}>
          Auf {planInfo.label} upgraden
        </button>
      </div>
      {showUpgrade && (
        <UpgradeModal
          currentPlan={currentPlan}
          preselectedPlan={requiredPlan}
          onClose={() => setShowUpgrade(false)}
        />
      )}
    </>
  );
}
